import React from 'react';
import PropTypes from 'prop-types';

import { DemoPage } from '../../partials';

// Import code snippets as text.
const html = require('!raw-loader!flexbox-patterns/src/examples/card.html');
const css = require('!raw-loader!flexbox-patterns/src/styles/card.css');

export const CardDemo = ({ name }) => (
  <DemoPage title={name} html={html} css={css}>
    <p>
      This component makes use of the same properties we&rsquo;ve been using so
      far:
    </p>

    <ol>
      <li>
        <code>display: flex</code>
      </li>
      <li>
        <code>flex-direction: column</code>
      </li>
      <li>
        <code>justify-content: center</code>
      </li>
      <li>
        <code>align-items: center</code>
      </li>
    </ol>

    <p>
      We&rsquo;re using these properties in the same way as in previous
      examples, primarily to order children along a vertical main axis, and to
      center children within their container.
    </p>

    <p>
      This is really nothing new, but when we get to the
      <em>next</em> example, things will get interesting&hellip;
    </p>
  </DemoPage>
);

CardDemo.propTypes = {
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./ui/views/demos/CardDemo.js